import { render, staticRenderFns } from "./PracticeSessionsDetails.vue?vue&type=template&id=a64da36e&"
import script from "./PracticeSessionsDetails.vue?vue&type=script&lang=js&"
export * from "./PracticeSessionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports